import { Card } from '@helix-ds/react'
import React from 'react'
import { useIntl } from 'react-intl'

type ProgressCardStep = {
  labelKey: string
  titleKey: string
  descriptionKey: string
}

type ProgressCardProps = {
  headingKey: string
  steps: ProgressCardStep[]
}

const ProgressCard: React.FC<ProgressCardProps> = ({ headingKey, steps }) => {
  const intl = useIntl()
  return (
    <section className="w-full font-sans">
      <Card padding="lg">
        <h2 className="text-text-heading text-2xl leading-9 font-semibold tracking-tight">
          {intl.formatMessage({ id: headingKey })}
        </h2>
        <ol className="border-border-base mt-6 space-y-7 border-l pl-4">
          {steps.map((step) => (
            <li key={step.labelKey} className="relative">
              <span
                className="border-background-primary bg-bg-secondary absolute top-[42px] -left-[23px] h-3 w-3 rounded-full border"
                aria-hidden
              />
              <span className="border-border-base bg-bg-secondary text-text-heading inline-flex rounded-full border px-2 py-1 text-xs font-medium">
                {intl.formatMessage({ id: step.labelKey })}
              </span>
              <h3 className="text-text-heading mt-3 text-base font-semibold">
                {intl.formatMessage({ id: step.titleKey })}
              </h3>
              <p className="text-text-body mt-2 text-sm leading-6">{intl.formatMessage({ id: step.descriptionKey })}</p>
            </li>
          ))}
        </ol>
      </Card>
    </section>
  )
}

export type { ProgressCardStep }
export default ProgressCard
